export const GET_LOCATION_REQUEST = 'geolocation/GET_LOCATION_REQUEST';
export const GET_LOCATION_SUCCESS = 'geolocation/GET_LOCATION_SUCCESS';
export const GET_LOCATION_FAILURE = 'geolocation/GET_LOCATION_FAILURE';
